<template>
	<div>
		<Popup
			v-model="trainingDisplay"
			title="训练记录"
			:width="950"
			:confirmBtnDisplay="false"
		>
			<div v-loading="trainingLoading" style="padding: 15px;">
				<div class="base_form_row" style="padding: 0;">
					<el-select v-model="productId" style="width: 200px;" @change="handleProductChange">
						<el-option v-for="v in filterData" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
					<el-select v-model="missionId" style="width: 200px;margin-left: 20px;" @change="handleMissionChange">
						<el-option v-for="v in missionList" :key="v.missionId" :value="v.missionId" :label="v.missionName"></el-option>
					</el-select>
				</div>
				<!-- 表格 -->
				<div class="base_table" style="margin-top: 20px;">
					<el-table
						:data="tableData"
						style="width: 100%"
					>
						<el-table-column
							prop="time"
							label="训练时间"
						>
						</el-table-column>
						<el-table-column
							prop="name"
							label="训练项目"
						>
						</el-table-column>
						<el-table-column
							prop="taskSection"
							label="任务节数"
						>
						</el-table-column>
						<el-table-column
							label="任务用时(分钟)"
						>
							<template slot-scope="scope">
								<span v-if="scope.row.isException && (scope.row.taskTime < 7 || scope.row.taskTime > 14)" style="color: #f00;">{{ scope.row.useTime }}</span>
								<span v-if="!scope.row.isException || (scope.row.taskTime >= 7 && scope.row.taskTime <= 14)">{{ scope.row.useTime }}</span>
							</template>
						</el-table-column>
						<el-table-column
							label="完成度(%)"
						>
							<template slot-scope="scope">
								<span v-if="scope.row.isException && scope.row.completeDegree < 100" style="color: #f00;">{{ scope.row.completeDegree }}</span>
								<span v-if="!scope.row.isException || scope.row.completeDegree >= 100">{{ scope.row.completeDegree }}</span>
							</template>
						</el-table-column>
						<el-table-column
							label="准确率(%)"
						>
							<template slot-scope="scope">
								<span
									v-if="scope.row.isException && scope.row.correctionDegree < 65" 
									style="cursor: pointer;color: #f00;text-decoration: underline;"
									@click="handleCorrectionClick(scope.row)"
								>{{ scope.row.correctionDegree }}</span>
								<span 
									v-if="!scope.row.isException || scope.row.correctionDegree >= 65"
									style="cursor: pointer;text-decoration: underline;"
									@click="handleCorrectionClick(scope.row)"
								>{{ scope.row.correctionDegree }}</span>
							</template>
						</el-table-column>
						<el-table-column
							prop="comment"
							label="训练评价"
						>
						</el-table-column>
					</el-table>
				</div>
				<!-- 表格 end -->
				
				<!-- 页码 -->
				<div class="clear_both" style="margin-top: 20px;">
					<div class="base_pager" style="float: right;">
						<el-pagination 
							layout="total, prev, pager, next, jumper" 
							next-text="下一页" 
							:total="total"
							:current-page="page"
							@current-change="handlePageChange"
						>
						</el-pagination>
					</div>
				</div>
				<!-- 页码 end-->
				
				<!-- 折线图 -->
				<div v-if="missionId && trainingChartData.length" ref="training_chart" style="height: 350px;margin-top: 20px;border: 1px solid #ccc;border-radius: 10px;"></div>
				<!-- 折线图 end -->
			</div>
		</Popup>
		
		<!-- 准确率 -->
		<Popup
			v-model="correctionDisplay"
			title="准确率"
			:confirmBtnDisplay="false"
		>
			<div v-loading="correctionLoading" style="padding: 15px;">
				<p v-if="false" style="text-indent: 2em;">若该用户训练任务难度异常，可能是因为训练过程中未按照要求努力辨认训练图片、训练距离异常、训练环境高度过高等造成。</p>
				<p v-if="false" style="text-indent: 2em;">如有需要，请点击下方“重置任务难度”按钮，明天将为用户重新设置训练任务难度，请叮嘱用户认真训练。</p>
				<div class="com_correction_box">
					<!-- <div class="in_top">
						<div class="in_question"><i class="el-icon-question"></i>查看说明</div>
					</div> -->
					<div ref="correction_chart" style="height: 350px;"></div>
				</div>
			</div>
		</Popup>
		<!-- 准确率 end -->
	</div>
</template>

<script>
	import Api from "../../../../../api/index.js";
	import Echarts from "echarts";
	import BaseMethods from '../../../../../assets/js/base.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: [Number, String],
				required: true
			},
			fid: {
				type: [Number, String],
				required: true
			},
			code: {
				type: [Number, String],
				required: true
			}
		},
		mounted () {
			this.correctionChartData = [];
			this.display && (this.trainingDisplay = true);
		},
		data () {
			return {
				trainingLoading: false,
				trainingDisplay: false,
				filterData: [],
				page: 1,
				total: 0,
				productId: '',
				missionList: [],
				missionId: null,
				tableData: [],
				trainingChartData: [],
				correctionDisplay: false,
				correctionLoading: false
			}
		},
		methods: {
			/************************* @Events *********************************/
			// 改变产品类型
			handleProductChange (val) {
				const that = this;
				that.filterData.forEach((v) => {
					if (v.id == val) {
						that.missionList = [{missionId: null,missionName: '全部'},...v.child];
						that.missionId = this.missionList[0].missionId;
					}
				});
				that.page = 1;
				that.missionId ? that.getTrainingChartData() : that.getTrainingPageData();
			},
			// 改变产品类型
			handleMissionChange () {
				this.page = 1;
				this.missionId ? this.getTrainingChartData() : this.getTrainingPageData();
			},
			// 点击页码
			handlePageChange (page) {
				if (this.page != page) {
					this.page = page;
					this.missionId ? this.getTrainingChartData() : this.getTrainingPageData();
				}
			},
			// 点击正确率
			handleCorrectionClick (data) {
				const that = this;
				this.missionObj = data;
				this.getCorrectionData(() => {
					// that.trainingDisplay = false;
					that.correctionDisplay = true;
					that.$nextTick(() => {
						that.createCorrectionEchart();
					});
				});
			},
			// 重置任务难度
			handleResetTaskDiffClick() {
				const that = this;
				this.$confirm(
					'此操作将重置任务难度，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.resetTaskDiff();
					}
				).catch(
					() => {}
				);
			},
			
			/************************* @Function *********************************/
			// 请求筛选数据
			getFilterData() {
				const that = this;
				that.trainingLoading = true;
				var requestData = {
					userId: that.uid
				};
				Api.findTrainingFilterData(requestData).then((res) => {
					if (res.data.success && res.data.data.length) {
						var _list = [];
						res.data.data.forEach((v) => {
							var _isBe = false;
							_list.forEach((fv) => {
								if (fv.id == v.productId) {
									_isBe = true;
									fv.child.push({
										missionId: v.missionId,
										missionName: v.missionName
									});
								}
							});
							!_isBe && _list.push({
								id: v.productId,
								name: v.productName,
								child: [{
									missionId: v.missionId,
									missionName: v.missionName
								}]
							});
						});
						that.filterData = _list;
						if (that.filterData.length) {
							that.productId = that.filterData[0].id;
							that.missionList = [{missionId: null,missionName: '全部'},...that.filterData[0].child];
							that.missionId = that.missionList[0].missionId;
						}
						that.getTrainingPageData();
					} else {
						that.trainingLoading = false;
						that.$message.warning('该用户暂无训练记录！！！');
					}
				}, (e) => {
					that.trainingLoading = false;
					that.$message.error(e.message);
				});
			},
			// 请求训练图表的数据
			getTrainingChartData () {
				const that = this;
				that.trainingLoading = true;
				var requestData = {
					endTime: null,
					id: null,
					limit: null,
					missionName: null,
					missionTypeId: that.missionId,
					pageNum: null,
					productType: null,
					startTime: null,
					ucode: that.code,
					uenterpriseId: that.fid,
					uuserId: null,
					versionFlagId: that.productId,
					careful: 1
				};
				Api.findUserTrainingChartData(requestData).then((res) => {
					that.trainingLoading = false;
					if (res.data.success) {
						let chart_data = [];
						let chart_final = [];
						that.getTrainingPageData();
						chart_data = res.data.data.length ? res.data.data : [];
						chart_data.forEach(v => {
							v.missionFinishRate >= 100 && chart_final.push(v);
						});
						that.trainingChartData = chart_final;
						that.tableEchart && that.tableEchart.dispose();
						that.$nextTick(() => {
							that.trainingChartData.length && that.createTrainingEchart();
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.trainingLoading = false;
					that.$message.error(e.message);
				});
			},
			// 请求训练分页的数据
			getTrainingPageData () {
				const that = this;
				that.trainingLoading = true;
				var requestData = {
					endTime: null,
					id: null,
					limit: 10,
					missionName: null,
					missionTypeId: that.missionId,
					pageNum: that.page,
					productType: null,
					startTime: null,
					ucode: that.code,
					uenterpriseId: that.fid,
					uuserId: null,
					versionFlagId: that.productId
				};
				Api.findUserTrainingRec(requestData).then((res) => {
					that.trainingLoading = false;
					if (res.data.success) {
						var _data = res.data.data.data;
						that.total = res.data.data.totalItems;
						that.tableData = [];
						_data.forEach((v) => {
							that.tableData.push({
								productId: v.productId,
								missionId: v.missionId,
								missionRecId: v.missionRecId,
								missionPatientRelativeId: v.missionPatientRelativeId,
								name: v.missionName,
								taskSection: v.missionTag,
								taskTime: Math.ceil(v.missionUseTime / (v.missionFinishRate / 100) / 60),
								useTime: Math.ceil(v.missionUseTime / 60),
								completeDegree: v.missionFinishRate,
								correctionDegree: v.missionRec,
								comment: v.missionComment,
								time: BaseMethods.formatTime(v.createTime, 'yy-mm-dd hh:mm:ss'),
								isException: v.missionId != 300 && v.missionId != 301 && v.missionId != 302 && v.missionId != 303
							});
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.trainingLoading = false;
					that.$message.error(e.message);
				});
			},
			// 请求正确率数据
			getCorrectionData(callBack) {
				const that = this;
				that.trainingLoading = true;
				var requestData = {
					missionRecId: that.missionObj.missionRecId
				};
				Api.findUserCorrectRate(requestData).then((res) => {
					that.trainingLoading = false;
					if (res.data.success) {
						that.correctionChartData = res.data.data.length ? res.data.data : [];
						that.correctionEchart && that.correctionEchart.dispose();
						callBack && callBack();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.trainingLoading = false;
					that.$message.error(e.message);
				});
			},
			// 生成训练数据折线图
			createTrainingEchart() {
				var xData = this.trainingChartData.map(v => { return BaseMethods.formatTime(v.createTime); }),
					seriesData = this.trainingChartData.map(v => {
						return v.missionDisplayIndexAvg; 
					});
				this.tableEchart = Echarts.init(this.$refs.training_chart);
				var option = {
					dataZoom: [{
						type: 'inside',
						start: 0,
						end: 100
					}, {
						start: 0,
						end: 100,
						handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
						handleSize: '80%',
						handleStyle: {
							color: '#fff',
							shadowBlur: 3,
							shadowColor: 'rgba(0, 0, 0, 0.6)',
							shadowOffsetX: 2,
							shadowOffsetY: 2
						}
					}],
					tooltip: {
						trigger: 'axis'
					},
					grid: {
						show: false
					},
					xAxis: {
						type: 'category',
						data: xData,
						boundaryGap: false
					},
					yAxis: {
						name: '（结果指标）'
						// boundaryGap: [0, '100%']
					},
					series: [{
						name: '结果指标',
						type: 'line',
						smooth: true,
						symbolSize: 5,
						data: seriesData,
						areaStyle: {
							color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgb(255, 158, 68)'
							}, {
								offset: 1,
								color: 'rgb(255, 70, 131)'
							}])
						},
						sampling: 'average',
						itemStyle: {
							color: 'rgb(255, 70, 131)'
						}
					}]
				};
				this.tableEchart.setOption(option);
			},
			// 生成正确率折线图
			createCorrectionEchart () {
				var xData = [],
					seriesData = [];
				for (var index = this.correctionChartData.length - 1;index >= 0;index--) {
					xData.push(BaseMethods.formatTime(this.correctionChartData[index].createTime));
					seriesData.push(this.correctionChartData[index].blockAcc * 100);
				}
				this.correctionEchart = Echarts.init(this.$refs.correction_chart);
				var option = {
					dataZoom: [{
						type: 'inside',
						start: 0,
						end: 100
					}, {
						start: 0,
						end: 100,
						handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
						handleSize: '80%',
						handleStyle: {
							color: '#fff',
							shadowBlur: 3,
							shadowColor: 'rgba(0, 0, 0, 0.6)',
							shadowOffsetX: 2,
							shadowOffsetY: 2
						}
					}],
					tooltip: {
						trigger: 'axis'
					},
					grid: {
						show: false
					},
					xAxis: {
						type: 'category',
						data: xData,
						boundaryGap: false
					},
					yAxis: {
						name: '难度指标（%）'
						// boundaryGap: [0, '100%']
					},
					series: [{
						name: '难度指标',
						type: 'line',
						smooth: false,
						symbolSize: 5,
						data: seriesData,
						areaStyle: {
							color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgb(255, 158, 68)'
							}, {
								offset: 1,
								color: 'rgb(255, 70, 131)'
							}])
						},
						sampling: 'average',
						itemStyle: {
							color: 'rgb(255, 70, 131)'
						}
					}]
				};
				this.correctionEchart.setOption(option);
			},
			// 重置任务难度
			resetTaskDiff() {
				const that = this;
				that.correctionLoading = true;
				var requestData = {
					missionPatientRelativeId: that.missionObj.missionPatientRelativeId
				};
				Api.resetTaskDiff(requestData).then((res) => {
					that.correctionLoading = false;
					if (res.data.success) {
						that.correctionDisplay = false;
						that.trainingDisplay = false;
						that.$message.success(res.data.message);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.correctionLoading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display (newValue) {
				this.trainingDisplay = newValue;
			},
			trainingDisplay (newValue) {
				this.$emit("changeDisplay", newValue);
				if (newValue) {
					this.trainingLoading = false;
					this.filterData = [];
					this.page = 1;
					this.total = 0;
					this.productId = '';
					this.missionList = [];
					this.missionId = null;
					this.tableData = [];
					this.trainingChartData = [];
					this.tableEchart && this.tableEchart.dispose();
					this.getFilterData();
				}
			},
			correctionDisplay(newValue) {
				if (!newValue) {
					this.correctionChartData = [];
					this.missionObj = {};
					this.correctionLoading = false;
					this.correctionEchart && this.correctionEchart.dispose();
				}
			}
		}
	}
</script>

<style>
	.com_correction_box{ margin-top: 20px;border: 1px solid #ccc;border-radius: 10px; }
	.com_correction_box .in_top{ position: relative;height: 36px; }
	.com_correction_box .in_question{ position: absolute;top: 0;left: 15px;line-height: 36px;cursor: pointer; }
	.com_correction_box .el-icon-question{ margin: 9px 5px 0 0;font-size: 20px;vertical-align: top; }
</style>
